module.exports = "mutation cancelRequest($cancelRequestInput:CancelRequestInput!){cancelRequest(cancelRequestInput:$cancelRequestInput)}"